import { IonBackButton, IonButtons, IonText, IonTitle, IonToolbar } from '@ionic/react';
import React, { useContext } from "react";
import { InternetConnectionStatusContext } from "../contexts/InternetConnectionStatusContext";
import { isTest } from '../utilities/api';
import {ApiContext} from "../contexts/ApiContext";

export const Toolbar = ({ title, backButtonHref = null }) => {
    const {
        hasInternetConnection,
        internetConnectionType
    } = useContext(InternetConnectionStatusContext);

    const { unsyncedCount = 0, resubmitUpdates, stackProcessing } = useContext(ApiContext);

    return (
        <>
            <IonToolbar color='light'>
                { backButtonHref &&
                    (
                        <IonButtons slot="start">
                            <IonBackButton defaultHref={backButtonHref} />
                        </IonButtons>
                    )
                }
                <IonTitle>
                    {title}
                    { isTest() && <span> - TEST MODE</span> }
                </IonTitle>
                <IonButtons slot="end">
                    <IonText className={hasInternetConnection ? "conn-text" : "no-conn-text"}>
                        {hasInternetConnection ? internetConnectionType : 'offline'}
                    </IonText>
                </IonButtons>
            </IonToolbar>

            { unsyncedCount > 0 &&
                <div className="unsynced-banner" role="status" aria-live="polite">
                    <div className="unsynced-banner__message">Some of your updates have not synced yet</div>
                    { hasInternetConnection
                        ? (
                            <button
                                className="unsynced-banner__button"
                                onClick={resubmitUpdates}
                                disabled={!!stackProcessing}
                                aria-disabled={!!stackProcessing}
                            >
                                { stackProcessing ? 'Resubmitting...' : 'RESUBMIT NOW' }
                            </button>
                        )
                        : (
                            <div className="unsynced-banner__offline">They will sync when you are back online</div>
                        )
                    }
                </div>
            }
        </>
    );
};